import { createFileRoute } from '@tanstack/react-router';
import { NewLayoutRoute } from './-components';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/layouts/new')({
  component: NewLayoutRoute,
});
